module.exports = __webpack_public_path__ + "img/동행파워볼DD.1c9c6e30.png";